<template>
    <grid-loader :loading="isLoading" :color="spinnerColor" class="middle_abs"></grid-loader>
    <button class="returnBtn" @click="back">返回</button>
     <div class="mt-2 container bg-white" v-if="!isLoading">
     <p v-show="error">{{ error }}</p>   
   
      <div v-if="!isLoading && note!=null">
        <div v-if="!is_edit">
        <div class="mt-1 d-flex justify-content-center bg-white m-1">
         
            <div class="d-flex flex-column">
              <div class="row d-flex justify-content-center">
                <div v-for="(img,index) in note.imgs" :key="index" class="col m-1" style="width:25%">
                    <div>
                        <img :src="img" class="img mr-1" @click="view(img)">
                        
                        <div class="backBtn ml-1" @click="deleteItem(index)" v-if="note.url==undefined">删除</div>
                    </div>
                    
                </div>                      
                        
               </div>
              
               <div>
                <div class="p-1 d-flex flex-column justify-content-evenly full-width">
                <div>{{ note.title}}<span v-if="note.url==undefined" class="error-message">[未发布]</span></div>
                
                <div class="mt-1">生成日期：{{ localDatetime(note.createdDate) }}</div> 
                <div class="mt-1" :style="{ 'white-space': 'pre-wrap' }">{{note.content}}</div>
               </div>
               </div>
            </div>
           
        </div>


      






      </div>

      <div v-else>
          <div class="mt-1 d-flex flex-column bg-white m-1 p-1 pt-3">
            <!-- <div class="d-flex justify-content-start mt-1">
              <label class="btn " :class="!img_change?'btn-primary':' btn-secondary'" @click="changeTemplate(false)">保留模版</label>
                      <label class="btn ml-1" :class="img_change?'btn-primary':' btn-secondary'" @click="changeTemplate(true)">换模版</label>
            </div> -->

            <div class="row d-flex justify-content-center">
                <div v-for="(img,index) in note.imgs" :key="index" class="col m-1" style="width:25%">
                    <div>
                        <img :src="img" class="img mr-1" @click="view(img)">
                        
                        <div class="backBtn ml-1" @click="deleteItem(index)" v-if="note.url==undefined">删除</div>
                    </div>
                </div>                              
            </div>
            <div>
                <button class="btn normalBtn" @click='regenrate()'>重新生成配图</button>
            </div>

            <div class="d-flex justify-content">
             <div>标题：</div>
             <div class="flex-fill"> <input type="text mt-1" v-model="note.title" style="width: 100%;"></div>
            </div>
            <div class="d-flex justify-content mt-1" v-if="note.has_tempalte">
              图片标题： <div class="flex-fill"><textarea v-model="note.split_title" rows="5" style="width: 100%;"></textarea></div>
            </div>

            <div class="mt-1 d-flex justify-content">
              文案： <div class="flex-fill"><textarea v-model="note.content" rows="20" style="width: 100%;"></textarea></div>
            </div>

            <div class="mt-1  d-flex justify-content" >
              图片文案：<div class="flex-fill"><textarea v-model="note.img_content" rows="20" style="width: 100%;"></textarea></div>
            </div>

            <div class="d-flex justify-content">
             <div>标签：</div>
             <div class="flex-fill"> <input type="text mt-1" v-model="note.tags" style="width: 100%;"></div>
            </div>
           
            <div>

            </div>
              
          </div>

        </div>
        

         </div>
         <div class="d-flex justify-content-center p-1">
          <button class="btn normalBtn" @click="edit()" v-if="!is_edit">修改</button>

          <button class="btn normalBtn" @click="edit_note()" v-else>保存</button>
         </div>
        
     </div>

     <PopupWindow v-model:isShow="isView">
        <div v-if="selectedImg!=null" class="d-flex justify-content-center">
            <img :src="selectedImg" style="max-width: 8rem;">
        </div>
    </PopupWindow>

    <PopupWindow v-model:isShow="showPopup" >
                <TemplateChoosen @set_template="addTemplate"></TemplateChoosen>
    </PopupWindow>

   </template>
   
   <script>
   
   import GridLoader from 'vue-spinner/src/GridLoader.vue'
   import axios from 'axios';
   import moment from 'moment'
   import PopupWindow from "@/components/PopupWindow.vue";
   import TemplateChoosen from './TemplateChoosen.vue';

   export default {
     data(){
       return {
         isLoading:false,
         is_edit:false,
         note:null,
         isView:false,
         selectedImg:null,
         error:'',
         img_change:false,
         spinnerColor:"#262626",
         showPopup:false,
         selected_cover:null,
         selected_content:null,
         old_title:null,
         old_content:null,
         new_imgs:null,
         regenerate_img:false,
         img_title:null,
         img_content:null
         
       }
       
     },
    
     computed: {
     localDatetime() {
       return (datetimeString) => {
         let beijingTime = moment(datetimeString).utcOffset('+08:00').format('YYYY-MM-DD HH:mm:ss');
         return beijingTime
         
       }
     },
     
     formatDate(){
      return (datetimeString) => {
         let beijingTime = moment.utc(datetimeString).format('YYYY-MM-DD HH:mm:ss');
         return beijingTime
         
       }
     }


   },
   
     components: {
      GridLoader,
      PopupWindow,
      TemplateChoosen
     },
      setup(){
        var token=localStorage.getItem('sessionToken')
        axios.defaults.headers.common['X-Parse-Session-Token'] = token
        
     },
   
   
     mounted(){
      var token=localStorage.getItem('sessionToken')
       
          if(token==undefined || token==null ||token=='')
        {
          this.$router.push('/')
          return
        }
        axios.defaults.headers.common['X-Parse-Session-Token'] = token
        this.note_id=this.$route.params.id
       this.getNote()

     },
     methods:{
      async regenrate(){
        try{
            
            this.isLoading=true
            const response = await axios.post(this.domain+'xhs/new_template_img',
            {
              'note_id':this.note.objectId,
            'title':this.note.title,
            'img_content':this.note.img_content,
            'split_title':this.note.split_title
          });

            var data=response.data
            console.log(data)
            if(data.status=='Suc')
            {
                this.img_title=this.note.split_title
                 this.img_content=this.note.img_content
                this.new_imgs=data.imgs
                this.note.imgs=this.new_imgs
                this.regenerate_img=false;
                console.log(this.note.imgs)
                
            }
        }
        catch(error)
        {
            console.error(data)
        }
        finally
        {
            this.isLoading=false
        }


      },

      async edit_note(){
        try{
            
            this.isLoading=true

            console.log(this.note.has_tempalte)
            console.log(this.img_content)
            console.log(this.note.content)
            if(this.note.has_tempalte)
            {
              console.log('has template')
              console.log(this.img_content==this.note.img_content)
              if(this.img_title==this.note.split_title && this.img_content==this.note.img_content)
                {
                  this.regenerate_img=false;
                }
                else
                {
                  this.regenerate_img=true;
                }
            }
            else
            {
              this.regenerate_img=false
            }
           
            console.log(this.regenerate_img)
            const response = await axios.post(this.domain+'xhs/edit_note',{'note_id':this.note.objectId,
            'imgs':this.note.imgs,
            'title':this.note.title,
            'content':this.note.content,
            'split_title':this.note.split_title,
            'img_content':this.note.img_content,
            'tags':this.note.tags,
            'regenerate_img':this.regenerate_img});

            var data=response.data
            console.log(data)
            if(data.status=='Suc')
            {
                this.note.imgs=data.imgs
             
                this.is_edit=false;
                
            }
        }
        catch(error)
        {
            console.error(data)
        }
        finally
        {
            this.isLoading=false
        }


      },


      changeTemplate(change){
        this.img_change=change
        if(this.img_change)
        {
          this.showPopup=true
        }

      },
      addTemplate(data){
      this.showPopup=false;
      this.selected_cover=data['cover']
      this.selected_content=data['content']

    },

      edit(){
        this.is_edit=true;
      },
      back(){
        this.$router.go(-1)
      },
      view(img){
        this.isView=true;
        this.selectedImg=img;
      },
      async deleteItem(index){
        console.log(this.note.imgs.length)
    
        if(this.note.imgs.length==1)
        {
            alert('必须保留一张图片')
            return
        }
        if (window.confirm("确定要删除吗?")) {
            this.isLoading=true
            this.note.imgs.splice(index,1)

            try{
            
                this.isLoading=true
                const response = await axios.post(this.domain+'xhs/update_note',{'index':index,'note_id':this.note_id});

                var data=response.data
                if(data.status!='Suc')
                {
                    console.error(data)
                    
                }
            }
            catch(error)
            {
                console.error(data)
            }
            finally
            {
                this.isLoading=false
            }
                    
        }
        
      },
       async getNote(){
         try{
          
            this.isLoading=true
             const response = await axios.get(this.domain+'xhs/get_note_by_id?note_id='+this.note_id);

             var data=response.data
             if(data.status=='Suc')
             {
                console.log(data)

                 this.note=data['note']
                 this.old_title=this.note.title
                 this.old_content=this.note.content
                 this.img_title=this.note.split_title
                 this.img_content=this.note.img_content

             }
             else
             {
                 console.error(data)
                 
             }
         }
         catch(error)
         {
             console.error(data)
         }
         finally
         {
            this.isLoading=false
         }
       },
      

       
     }
      
     
   };
   </script>
<style scoped>
.green_border{
    border:0.0375 solid green;
}
.account_icon{
  width: 0.35rem;
height: 0.35rem;
border-radius: 0.35rem;
}
.img{
    width:3.5rem;
    border-radius: 0.125rem 0 0 0.125rem;
}
.card{
  background: white;
  border-radius: 0.125rem;
  width:30%;
  height:2rem;
}
.cardRight{
  height:2rem;
}
.cardText{
  color: #262626;
 font-family: "Alibaba PuHuiTi";
 font-size: 0.175rem;
 font-style: normal;
 font-weight: 500;
 text-align: left;
}
.icon{
  width:0.175rem;
  height:0.175rem;
}

.pageBox{
  width: 0.3125rem;
  height:0.3125rem;
  border-radius: 0.125rem;
  cursor:pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  
 font-family: "Alibaba PuHuiTi";
 font-size: 0.175rem;
 font-style: normal;
 font-weight: 500;
}
.normalPage{
  background: white;
  color: #262626;
}

.selectedPageBox
{
  background: #3b64ff;
  color:white
}

</style>
   